import React, { useEffect, useState, useCallback } from 'react';
import { Phone, MessageCircle, ArrowUp } from 'lucide-react';
import { college } from '../mock/data';

export default function FloatingButtons() {
  const [show, setShow] = useState(false);

  const handleScroll = useCallback(() => {
    setShow(window.scrollY > 500);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="fixed z-50 bottom-5 right-5 flex flex-col gap-3">
      <a
        href={`https://wa.me/${college.phoneClean}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="w-12 h-12 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:scale-105 transition-transform"
      >
        <MessageCircle size={22} />
      </a>
      <a
        href={`tel:${college.phone.replace(/\s/g, '')}`}
        aria-label="Call"
        className="w-12 h-12 rounded-full bg-[#0B2E6E] text-white shadow-lg flex items-center justify-center hover:scale-105 transition-transform"
      >
        <Phone size={20} />
      </a>
      {show && (
        <button
          type="button"
          onClick={scrollToTop}
          aria-label="Back to top"
          className="w-12 h-12 rounded-full bg-white text-[#0B2E6E] shadow-lg border border-slate-200 flex items-center justify-center hover:scale-105 transition-transform"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
}
